<template>
    <validation-observer ref="loginValidation" #default="{ invalid }">
        <b-form @submit.prevent>
            <div class="mb-50 d-flex justify-content-end">
                <TowFactorTimer :seconds="3 * 60" @done="doneTimer"></TowFactorTimer>
            </div>
            <b-form-group label-for="otpCode" :label="$t('v4.Two-Factor Token')">
                <b-form-input id="otp" v-model="otpCode" name="otp-code" placeholder="OTP" autofocus />
            </b-form-group>
            <b-button variant="primary" type="submit" block :disabled="invalid || submitted" @click="validationOtpForm">
                {{ $t('v4.Send') }}
            </b-button>
        </b-form>
    </validation-observer>
</template>
<script>
import { ref, getCurrentInstance } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import TowFactorTimer from '@/components/TwoFactorTimer'
import utils from '@/auth/utils'
export default {
    components: {
        ValidationObserver,
        TowFactorTimer
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const otpCode = ref('')
        const submitted = ref(false)
        const otpVerificationTry = ref(0)

        const doneTimer = () => {
            context.emit('auth:base')
        }
        const validationOtpForm = () => {
            vm.$refs.loginValidation.validate().then(success => {
                submitted.value = true
                if (success) {
                    store.dispatch('createMemberAuthOtp', { otpCode: otpCode.value }).then((response) => {
                        localStorage.setItem('x-auth-token', response.token)
                        let nextPath = utils.getRouteForLoggedInUser()
                        utils.isUserMonths().then(haveBilingData => {
                            if (!haveBilingData) {
                                nextPath = { name: 'infomation' }
                            }
                            if (utils.isTcPopsLogin()) {
                                nextPath = { name: 'agreement' }
                            }
                            vm.$router.push(nextPath)
                        })
                    }).catch(error => {
                        otpVerificationTry.value++
                        submitted.value = false
                        otpCode.value = ''
                        vm.$refs.loginValidation.setErrors(error?.response?.data ?? '')
                        if (otpVerificationTry.value === 3) {
                            localStorage.removeItem('x-auth-token')
                            doneTimer()
                        }
                    })
                }
            })
        }
        return {
            otpCode,
            validationOtpForm,
            doneTimer,
            submitted
        }
    }
}
</script>
